var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLevel4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 162,
    viewBox: "0 0 130 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.567 107.561V56.2732L126.9 68.1979L124.953 104.65L116.567 107.561Z",
    fill: "url(#paint0_linear_39935_59277)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.1152 124.551V152.349L64.9803 159.607L85.8852 152.349V124.551H44.1152Z",
    fill: "#9B9B9B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.3799 124.551V150.714L64.9796 157.214L83.6191 150.714V124.551H46.3799Z",
    fill: "url(#paint1_radial_39935_59277)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.8855 124.551V152.349L88.1509 153.944V124.551H85.8855Z",
    fill: "url(#paint2_linear_39935_59277)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.8852 152.349V124.551H83.6199V150.714L85.8852 152.349Z",
    fill: "url(#paint3_linear_39935_59277)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.3806 150.714V124.551H44.1152V152.349L46.3806 150.714Z",
    fill: "url(#paint4_linear_39935_59277)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.115 152.349V124.551H41.8496V153.944L44.115 152.349Z",
    fill: "url(#paint5_linear_39935_59277)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.6392 154.263L64.9801 159.607V162L49.6392 156.656L41.8496 153.944L44.115 152.349L49.6392 154.263Z",
    fill: "url(#paint6_linear_39935_59277)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.9803 159.608L49.6395 154.263L44.1152 152.349L46.3806 150.714L49.6395 151.871L64.9803 157.215V159.608Z",
    fill: "url(#paint7_linear_39935_59277)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.9805 159.607L80.361 154.263L85.8853 152.349L88.1507 153.944L80.361 156.656L64.9805 162V159.607Z",
    fill: "url(#paint8_linear_39935_59277)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.8853 152.349L80.361 154.263L64.9805 159.608V157.215L80.361 151.871L83.62 150.714L85.8853 152.349Z",
    fill: "url(#paint9_linear_39935_59277)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4328 107.561V56.2732L3.09961 68.1979L5.04702 104.65L13.4328 107.561Z",
    fill: "url(#paint10_linear_39935_59277)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4333 83.8319L15.4602 82.436L64.9801 99.6251V101.779L13.4333 83.8319Z",
    fill: "url(#paint11_linear_39935_59277)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.567 83.8319L114.5 82.436L64.9805 99.6251V101.779L116.567 83.8319Z",
    fill: "url(#paint12_linear_39935_59277)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4333 9.41211L15.4602 11.4062V82.4359L13.4333 83.8317V9.41211Z",
    fill: "url(#paint13_linear_39935_59277)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.9803 152.429V101.778L13.4336 83.8316L11.3669 83.1138V133.724L64.9803 152.429Z",
    fill: "url(#paint14_linear_39935_59277)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.9805 101.778V152.429L118.634 133.724V83.1138L116.567 83.8316L64.9805 101.778Z",
    fill: "url(#paint15_linear_39935_59277)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.9803 150.236L13.4336 132.289L11.3669 133.724L64.9803 152.429V150.236Z",
    fill: "url(#paint16_linear_39935_59277)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.567 132.289L64.9805 150.236V152.429L118.634 133.724L116.567 132.289Z",
    fill: "url(#paint17_linear_39935_59277)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3662 7.85669V62.6145L3.09961 68.198L5.04702 104.65L11.3662 106.844V133.724L13.4328 132.288V107.561V84.3901V61.2187V9.41208L11.3662 7.85669Z",
    fill: "url(#paint18_linear_39935_59277)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.515 76.0551L119.189 72.9443V96.4747L123.561 93.9222L124.515 76.0551Z",
    fill: "#808080"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4597 11.4065V82.3564L64.9795 99.6252L114.499 82.3564V11.4065L64.9795 4.14795L15.4597 11.4065Z",
    fill: "url(#paint19_radial_39935_59277)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.2192 88.9365L103.77 9.85071L114.5 11.4061V82.4358L64.9803 99.6249L34.2192 88.9365Z",
    fill: "url(#paint20_radial_39935_59277)"
  }), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7735 17.7474V30.39L20.9453 28.5554V16.1521L65.0204 9.69128L93.5161 13.8789V15.7134L65.0204 11.5258L22.7735 17.7075V17.7474ZM22.7735 31.7061V54.7179L20.0312 57.4698V79.1656L64.9806 94.8392L109.93 79.1656V42.7933L109.851 42.7135L109.016 41.876L107.188 40.0414V17.7873L94.3507 15.9129V13.161L64.9806 8.85376L20.0312 15.4343V28.9941L22.7735 31.746V31.7061ZM22.7735 55.9942V77.1715L54.3295 88.1789V90.1331L20.9453 78.4876V57.8288L22.7735 55.9942ZM55.2436 88.4979L65.0204 91.8879L74.7972 88.4979V90.4522L65.0204 93.8421L55.2436 90.4522V88.4979ZM75.6715 88.1789L107.227 77.1715V41.3176L109.056 43.1522V78.4876L75.6715 90.1331V88.1789ZM23.6876 18.5451V76.5334L65.0204 90.9307L106.353 76.5334V18.5451L65.0204 12.483L23.6876 18.5451Z",
    fill: "url(#paint21_radial_39935_59277)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4336 9.41213L64.9803 2.07386V0L11.3669 7.85674L13.4336 9.41213Z",
    fill: "url(#paint22_linear_39935_59277)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.9801 2.07397L13.4333 9.41225L15.4602 11.4063L64.9801 4.14784V2.07397Z",
    fill: "url(#paint23_linear_39935_59277)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.567 9.41211L114.5 11.4062V82.4359L116.567 83.8317V9.41211Z",
    fill: "url(#paint24_linear_39935_59277)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.567 9.41213L64.9805 2.07386V0L118.634 7.85674L116.567 9.41213Z",
    fill: "url(#paint25_linear_39935_59277)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.9805 2.07397L116.567 9.41225L114.5 11.4063L64.9805 4.14784V2.07397Z",
    fill: "url(#paint26_linear_39935_59277)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.969 41.4374V15.3547L95.3042 13.201V15.0755L108.141 16.95V39.6428L109.969 41.4374Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0312 30.2301V56.1533L21.8594 54.2789V32.0647L20.0312 30.2301Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.9795 91.8881L55.2424 88.4583V90.4125L64.9795 93.8024L74.7563 90.4125V88.4583L64.9795 91.8881Z",
    fill: "url(#paint27_radial_39935_59277)"
  }), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.9802 111.749L64.0263 102.497L22.2961 86.9429L64.9802 101.779V111.749Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4334 50.9293L12.6783 9.69141L11.6052 8.05625L13.5526 8.81401L29.9665 7.0592L13.4334 9.41224V50.9293Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8486 6.22171L64.4636 1.43589L64.9803 0.159668V2.074L35.8486 6.22171Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7736 129.895H103.968V125.907H95.0261V110.433H90.7736V129.895ZM74.9161 129.895H88.389V125.907H79.1686V121.72H87.2364V117.731H79.1686V114.381H88.389V110.393H74.9161V129.855V129.895ZM67.0867 129.895L73.2469 111.191V109.556L69.3521 109.875L65.3778 121.839L65.0201 123.873H64.9009L64.5432 121.839L60.5689 109.875L56.6741 109.556V111.191L62.8342 129.895H67.047H67.0867ZM41.6114 129.895H55.0843V125.907H45.864V121.72H53.9318V117.731H45.864V114.381H55.0843V110.393H41.6114V129.855V129.895ZM25.9924 129.895H39.1871V125.907H30.2449V110.433H25.9924V129.895Z",
    fill: "#4D5E6E"
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7736 128.26H103.968V124.272H95.0261V108.798H90.7736V128.26ZM74.9161 128.26H88.389V124.272H79.1686V120.084H87.2364V116.096H79.1686V112.746H88.389V108.758H74.9161V128.22V128.26ZM67.0867 128.26L73.2469 109.556L69.3521 108.24L65.3778 120.204L65.0201 122.238H64.9009L64.5432 120.204L60.5689 108.24L56.6741 109.556L62.8342 128.26H67.047H67.0867ZM41.6114 128.26H55.0843V124.272H45.864V120.084H53.9318V116.096H45.864V112.746H55.0843V108.758H41.6114V128.22V128.26ZM25.9924 128.26H39.1871V124.272H30.2449V108.798H25.9924V128.26Z",
    fill: "url(#paint28_linear_39935_59277)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6924 113.504V113.783C16.6924 114.341 17.1296 114.78 17.686 114.78H20.0705C20.6269 114.78 21.0641 114.341 21.0641 113.783V113.504H16.6924Z",
    fill: "url(#paint29_linear_39935_59277)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1505 112.706H17.6069C17.3287 112.706 17.0505 112.945 17.0505 113.265C17.0505 113.544 17.289 113.823 17.6069 113.823H20.1505C20.4287 113.823 20.7069 113.584 20.7069 113.265C20.7069 112.985 20.4684 112.706 20.1505 112.706Z",
    fill: "url(#paint30_linear_39935_59277)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6924 118.569V118.848C16.6924 119.406 17.1296 119.845 17.686 119.845H20.0705C20.6269 119.845 21.0641 119.406 21.0641 118.848V118.569H16.6924Z",
    fill: "url(#paint31_linear_39935_59277)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1505 117.732H17.6069C17.3287 117.732 17.0505 117.971 17.0505 118.29C17.0505 118.569 17.289 118.848 17.6069 118.848H20.1505C20.4287 118.848 20.7069 118.609 20.7069 118.29C20.7069 118.011 20.4684 117.732 20.1505 117.732Z",
    fill: "url(#paint32_linear_39935_59277)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6924 123.514V123.793C16.6924 124.352 17.1296 124.791 17.686 124.791H20.0705C20.6269 124.791 21.0641 124.352 21.0641 123.793V123.514H16.6924Z",
    fill: "url(#paint33_linear_39935_59277)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1505 122.717H17.6069C17.3287 122.717 17.0505 122.956 17.0505 123.275C17.0505 123.554 17.289 123.834 17.6069 123.834H20.1505C20.4287 123.834 20.7069 123.594 20.7069 123.275C20.7069 122.996 20.4684 122.717 20.1505 122.717Z",
    fill: "url(#paint34_linear_39935_59277)"
  }), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1106 112.507H17.726C17.1696 112.507 16.7324 112.945 16.7324 113.504C16.7324 114.062 17.1696 114.501 17.726 114.501H20.1106C20.667 114.501 21.1042 114.062 21.1042 113.504C21.1042 112.945 20.667 112.507 20.1106 112.507Z",
    fill: "url(#paint35_linear_39935_59277)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1106 117.572H17.726C17.1696 117.572 16.7324 118.01 16.7324 118.569C16.7324 119.127 17.1696 119.566 17.726 119.566H20.1106C20.667 119.566 21.1042 119.127 21.1042 118.569C21.1042 118.01 20.667 117.572 20.1106 117.572Z",
    fill: "url(#paint36_linear_39935_59277)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1106 122.557H17.726C17.1696 122.557 16.7324 122.996 16.7324 123.554C16.7324 124.112 17.1696 124.551 17.726 124.551H20.1106C20.667 124.551 21.1042 124.112 21.1042 123.554C21.1042 122.996 20.667 122.557 20.1106 122.557Z",
    fill: "url(#paint37_linear_39935_59277)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.896 113.504V113.783C108.896 114.341 109.333 114.78 109.889 114.78H112.274C112.83 114.78 113.267 114.341 113.267 113.783V113.504H108.896Z",
    fill: "url(#paint38_linear_39935_59277)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.354 112.706H109.811C109.532 112.706 109.254 112.946 109.254 113.265C109.254 113.544 109.493 113.823 109.811 113.823H112.354C112.632 113.823 112.911 113.584 112.911 113.265C112.911 112.985 112.672 112.706 112.354 112.706Z",
    fill: "url(#paint39_linear_39935_59277)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.896 118.569V118.848C108.896 119.406 109.333 119.845 109.889 119.845H112.274C112.83 119.845 113.267 119.406 113.267 118.848V118.569H108.896Z",
    fill: "url(#paint40_linear_39935_59277)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.354 117.732H109.811C109.532 117.732 109.254 117.971 109.254 118.29C109.254 118.569 109.493 118.848 109.811 118.848H112.354C112.632 118.848 112.911 118.609 112.911 118.29C112.911 118.011 112.672 117.732 112.354 117.732Z",
    fill: "url(#paint41_linear_39935_59277)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.896 123.514V123.794C108.896 124.352 109.333 124.791 109.889 124.791H112.274C112.83 124.791 113.267 124.352 113.267 123.794V123.514H108.896Z",
    fill: "url(#paint42_linear_39935_59277)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.354 122.717H109.811C109.532 122.717 109.254 122.956 109.254 123.275C109.254 123.554 109.493 123.834 109.811 123.834H112.354C112.632 123.834 112.911 123.594 112.911 123.275C112.911 122.996 112.672 122.717 112.354 122.717Z",
    fill: "url(#paint43_linear_39935_59277)"
  }), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.274 112.507H109.889C109.333 112.507 108.896 112.945 108.896 113.504C108.896 114.062 109.333 114.501 109.889 114.501H112.274C112.83 114.501 113.267 114.062 113.267 113.504C113.267 112.945 112.83 112.507 112.274 112.507Z",
    fill: "url(#paint44_linear_39935_59277)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.274 117.572H109.889C109.333 117.572 108.896 118.01 108.896 118.569C108.896 119.127 109.333 119.566 109.889 119.566H112.274C112.83 119.566 113.267 119.127 113.267 118.569C113.267 118.01 112.83 117.572 112.274 117.572Z",
    fill: "url(#paint45_linear_39935_59277)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.274 122.557H109.889C109.333 122.557 108.896 122.996 108.896 123.554C108.896 124.112 109.333 124.551 109.889 124.551H112.274C112.83 124.551 113.267 124.112 113.267 123.554C113.267 122.996 112.83 122.557 112.274 122.557Z",
    fill: "url(#paint46_linear_39935_59277)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M20.0303 56.6321C21.3692 56.6321 22.4546 50.6147 22.4546 43.1919C22.4546 35.7691 21.3692 29.7517 20.0303 29.7517C18.6914 29.7517 17.606 35.7691 17.606 43.1919C17.606 50.6147 18.6914 56.6321 20.0303 56.6321Z",
    fill: "url(#paint47_radial_39935_59277)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.433 16.1123C14.5061 16.1123 15.3804 20.938 15.3804 26.8804C15.3804 32.8228 14.5061 37.6485 13.433 37.6485C12.3599 37.6485 11.4856 32.8228 11.4856 26.8804C11.4856 20.938 12.3599 16.1123 13.433 16.1123Z",
    fill: "url(#paint48_radial_39935_59277)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M18.8781 128.5C21.5998 128.5 23.8062 124.089 23.8062 118.649C23.8062 113.208 21.5998 108.798 18.8781 108.798C16.1564 108.798 13.95 113.208 13.95 118.649C13.95 124.089 16.1564 128.5 18.8781 128.5Z",
    fill: "url(#paint49_radial_39935_59277)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M111.082 128.5C113.803 128.5 116.01 124.089 116.01 118.649C116.01 113.208 113.803 108.798 111.082 108.798C108.36 108.798 106.154 113.208 106.154 118.649C106.154 124.089 108.36 128.5 111.082 128.5Z",
    fill: "url(#paint50_radial_39935_59277)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.969 15.1954C110.804 15.1954 111.479 21.0581 111.479 28.3166C111.479 35.5751 110.804 41.4377 109.969 41.4377C109.135 41.4377 108.459 35.5751 108.459 28.3166C108.459 21.0581 109.135 15.1954 109.969 15.1954Z",
    fill: "url(#paint51_radial_39935_59277)"
  }), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.9 68.198L118.634 62.6145V7.85669L116.567 9.41208V61.2187V84.3901V107.561V132.288L118.634 133.724V106.844L124.953 104.65L126.9 68.198Z",
    fill: "url(#paint52_linear_39935_59277)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.7025 101.779C70.7025 104.929 68.1589 107.482 65.0192 107.482C61.8795 107.482 59.3359 104.929 59.3359 101.779C59.3359 98.6279 61.8795 96.0754 65.0192 96.0754C68.1589 96.0754 70.7025 98.6279 70.7025 101.779Z",
    fill: "url(#paint53_radial_39935_59277)"
  }), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.48413 76.0551L10.7699 72.9443V96.4747L6.43796 93.9222L5.48413 76.0551Z",
    fill: "url(#paint54_linear_39935_59277)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.83594 76.8124L9.45898 75.257V94.2009L7.71027 93.1639L6.83594 76.8124Z",
    fill: "url(#paint55_radial_39935_59277)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.43872 93.9218L7.7105 93.1641L9.4592 94.201L10.7707 96.4743L6.43872 93.9218Z",
    fill: "url(#paint56_linear_39935_59277)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.83539 76.8129L5.48413 76.0551L10.7699 72.9443L9.45844 75.2575L6.83539 76.8129Z",
    fill: "url(#paint57_linear_39935_59277)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.48438 76.0549L6.83564 76.8127L7.70998 93.1643L6.4382 93.922L5.48438 76.0549Z",
    fill: "url(#paint58_linear_39935_59277)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.45923 94.2014V75.2575L10.7707 72.9443V96.4747L9.45923 94.2014Z",
    fill: "url(#paint59_linear_39935_59277)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.515 76.0551L119.189 72.9443V96.4747L123.561 93.9222L124.515 76.0551Z",
    fill: "url(#paint60_linear_39935_59277)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.125 76.8124L120.501 75.257V94.2009L122.29 93.1639L123.125 76.8124Z",
    fill: "url(#paint61_radial_39935_59277)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.561 93.9218L122.289 93.1641L120.501 94.201L119.189 96.4743L123.561 93.9218Z",
    fill: "url(#paint62_linear_39935_59277)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.124 76.8129L124.515 76.0551L119.189 72.9443L120.501 75.2575L123.124 76.8129Z",
    fill: "url(#paint63_linear_39935_59277)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.515 76.0549L123.124 76.8127L122.289 93.1643L123.561 93.922L124.515 76.0549Z",
    fill: "url(#paint64_linear_39935_59277)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.501 94.2014V75.2575L119.189 72.9443V96.4747L120.501 94.2014Z",
    fill: "url(#paint65_linear_39935_59277)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.14732 64.8481C12.6383 64.8481 16.2946 73.7418 16.2946 84.7492C16.2946 95.7566 12.6383 104.65 8.14732 104.65C3.65636 104.65 0 95.7566 0 84.7492C0 73.7418 3.65636 64.8481 8.14732 64.8481Z",
    fill: "url(#paint66_radial_39935_59277)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.853 64.8483C126.344 64.8483 130 73.7419 130 84.7493C130 95.7568 126.344 104.65 121.853 104.65C117.362 104.65 113.705 95.7568 113.705 84.7493C113.705 73.7419 117.362 64.8483 121.853 64.8483Z",
    fill: "url(#paint67_radial_39935_59277)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.75,
    d: "M9.22018 125.189C10.164 125.189 10.9291 107.065 10.9291 84.7088C10.9291 62.3522 10.164 44.2286 9.22018 44.2286C8.27635 44.2286 7.51123 62.3522 7.51123 84.7088C7.51123 107.065 8.27635 125.189 9.22018 125.189Z",
    fill: "url(#paint68_radial_39935_59277)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.75,
    d: "M7.31303 64.4487C7.71046 64.4487 8.02841 73.5418 8.02841 84.7087C8.02841 95.8757 7.71046 104.969 7.31303 104.969C6.9156 104.969 6.59766 95.8757 6.59766 84.7087C6.59766 73.5418 6.9156 64.4487 7.31303 64.4487Z",
    fill: "url(#paint69_radial_39935_59277)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.75,
    d: "M120.779 125.229C121.733 125.229 122.488 107.083 122.488 84.7489C122.488 62.4151 121.733 44.2688 120.779 44.2688C119.825 44.2688 119.07 62.4151 119.07 84.7489C119.07 107.083 119.825 125.229 120.779 125.229Z",
    fill: "url(#paint70_radial_39935_59277)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.75,
    d: "M122.726 64.4495C122.329 64.4495 122.011 73.5425 122.011 84.7095C122.011 95.8764 122.329 104.969 122.726 104.969C123.124 104.969 123.442 95.8764 123.442 84.7095C123.442 73.5425 123.124 64.4495 122.726 64.4495Z",
    fill: "url(#paint71_radial_39935_59277)"
  }), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6641 57.5233V26.1144H71.4373L46.0415 57.7917V67.9929H69.6887V77.4782H79.6641V67.9929H84.3538V57.5233H79.6641ZM69.013 44.7718L70.3643 42.2215L70.563 42.3557L69.7284 44.906V57.4786H59.5939L57.3286 58.4181L57.2093 58.1944L59.4747 56.6732L69.0528 44.7271L69.013 44.7718Z",
    fill: "url(#paint72_linear_39935_59277)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_39935_59277",
    x1: 116.567,
    y1: 81.9173,
    x2: 126.9,
    y2: 81.9173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B3840"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#204954"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_39935_59277",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(64.9796 157.214) scale(19.4741 19.5421)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3FFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#B0FFF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#A9FFF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#9CFFEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#89FFEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#71FFE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#53FFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#30FFDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#08FFD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_39935_59277",
    x1: 85.8855,
    y1: 139.228,
    x2: 88.1509,
    y2: 139.228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#335D94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#204270"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_39935_59277",
    x1: 83.6199,
    y1: 138.43,
    x2: 85.8852,
    y2: 138.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E76A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87B5F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_39935_59277",
    x1: 44.1152,
    y1: 138.43,
    x2: 46.3806,
    y2: 138.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#335D94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#204270"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_39935_59277",
    x1: 41.8496,
    y1: 139.228,
    x2: 44.115,
    y2: 139.228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E76A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87B5F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_39935_59277",
    x1: 41.8496,
    y1: 157.174,
    x2: 64.9801,
    y2: 157.174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F5382"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#446DA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_39935_59277",
    x1: 44.1152,
    y1: 155.181,
    x2: 64.9803,
    y2: 155.181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E76A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87B5F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_39935_59277",
    x1: 64.9805,
    y1: 157.174,
    x2: 88.1507,
    y2: 157.174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#204270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335D94"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_39935_59277",
    x1: 64.9805,
    y1: 155.181,
    x2: 85.8853,
    y2: 155.181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#77A5D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99C5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_39935_59277",
    x1: 3.09961,
    y1: 81.9173,
    x2: 13.4328,
    y2: 81.9173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#204954"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B3840"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_39935_59277",
    x1: 13.4333,
    y1: 92.1273,
    x2: 64.9801,
    y2: 92.1273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E76A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87B5F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_39935_59277",
    x1: 64.9805,
    y1: 92.1273,
    x2: 116.567,
    y2: 92.1273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#77A5D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99C5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_39935_59277",
    x1: 13.4333,
    y1: 46.6219,
    x2: 15.4602,
    y2: 46.6219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#335D94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#204270"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_39935_59277",
    x1: 64.7021,
    y1: 101.938,
    x2: 7.84582,
    y2: 135.624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87B5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A94C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_39935_59277",
    x1: 64.583,
    y1: 101.499,
    x2: 120.564,
    y2: 134.749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#335D94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42689C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_39935_59277",
    x1: 11.3669,
    y1: 142.339,
    x2: 64.9803,
    y2: 142.339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F5382"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#446DA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_39935_59277",
    x1: 64.9805,
    y1: 142.339,
    x2: 118.634,
    y2: 142.339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#204270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335D94"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_39935_59277",
    x1: 3.09961,
    y1: 70.7903,
    x2: 13.4328,
    y2: 70.7903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E76A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87B5F5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_39935_59277",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(64.9795 4.18783) scale(95.4628 95.7963)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0056BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#01429F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#033082"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#042571"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#05226B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#062060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#091D4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1C4A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_39935_59277",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.705 -14.7564) scale(126.303 126.745)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#284580"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_39935_59277",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.0184 15.8331) scale(127.893 128.34)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#67DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0068DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_39935_59277",
    x1: 11.3669,
    y1: 4.70607,
    x2: 64.9803,
    y2: 4.70607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7996B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCE2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_39935_59277",
    x1: 13.4333,
    y1: 6.74016,
    x2: 64.9801,
    y2: 6.74016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#204270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335D94"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_39935_59277",
    x1: 114.5,
    y1: 46.6219,
    x2: 116.567,
    y2: 46.6219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E76A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87B5F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_39935_59277",
    x1: 64.9805,
    y1: 4.70607,
    x2: 118.634,
    y2: 4.70607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87B5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E76A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_39935_59277",
    x1: 64.9805,
    y1: 6.74016,
    x2: 116.567,
    y2: 6.74016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F5382"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#446DA3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_39935_59277",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(64.9795 91.1303) scale(9.57807 9.61151)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0062B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_39935_59277",
    x1: 64.9803,
    y1: 128.26,
    x2: 64.9803,
    y2: 108.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2D6F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6F5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_39935_59277",
    x1: 18.8782,
    y1: 114.78,
    x2: 18.8782,
    y2: 113.504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#2C3B41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#316373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#35869E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#39A2C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3CB8DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#3EC7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#3FD0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#40D4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_39935_59277",
    x1: 18.8787,
    y1: 113.783,
    x2: 18.8787,
    y2: 112.706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78FAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_39935_59277",
    x1: 18.8782,
    y1: 119.805,
    x2: 18.8782,
    y2: 118.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#283B41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#1D6073"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#14809E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#0D9AC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#07AEDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#03BCEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#00C5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#00C8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_39935_59277",
    x1: 18.8787,
    y1: 118.848,
    x2: 18.8787,
    y2: 117.732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78FAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_39935_59277",
    x1: 18.8782,
    y1: 124.791,
    x2: 18.8782,
    y2: 123.514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#2C3B41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#316373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#35869E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#39A2C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3CB8DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#3EC7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#3FD0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#40D4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_39935_59277",
    x1: 18.8787,
    y1: 123.794,
    x2: 18.8787,
    y2: 122.717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78FAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_39935_59277",
    x1: 18.8786,
    y1: 114.501,
    x2: 18.8786,
    y2: 112.507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78FAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_39935_59277",
    x1: 18.8786,
    y1: 119.526,
    x2: 18.8786,
    y2: 117.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78FAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_39935_59277",
    x1: 18.8786,
    y1: 124.511,
    x2: 18.8786,
    y2: 122.557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78FAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_39935_59277",
    x1: 111.081,
    y1: 114.78,
    x2: 111.081,
    y2: 113.504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#2C3B41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#316373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#35869E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#39A2C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3CB8DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#3EC7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#3FD0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#40D4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_39935_59277",
    x1: 111.082,
    y1: 113.783,
    x2: 111.082,
    y2: 112.706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78FAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_39935_59277",
    x1: 111.081,
    y1: 119.805,
    x2: 111.081,
    y2: 118.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#2C3B41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#316373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#35869E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#39A2C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3CB8DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#3EC7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#3FD0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#40D4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_39935_59277",
    x1: 111.082,
    y1: 118.848,
    x2: 111.082,
    y2: 117.732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78FAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_39935_59277",
    x1: 111.081,
    y1: 124.791,
    x2: 111.081,
    y2: 123.514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#2C3B41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#316373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#35869E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#39A2C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3CB8DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#3EC7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#3FD0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#40D4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_39935_59277",
    x1: 111.082,
    y1: 123.794,
    x2: 111.082,
    y2: 122.717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78FAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_39935_59277",
    x1: 111.081,
    y1: 114.501,
    x2: 111.081,
    y2: 112.507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78FAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_39935_59277",
    x1: 111.081,
    y1: 119.526,
    x2: 111.081,
    y2: 117.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78FAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_39935_59277",
    x1: 111.081,
    y1: 124.511,
    x2: 111.081,
    y2: 122.557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78FAFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint47_radial_39935_59277",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.439 44.2256) rotate(-90) scale(13.3142 2.2113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCC14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#8F8F0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#5C5C09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#343405"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#171702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#060600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint48_radial_39935_59277",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.4045 28.0976) rotate(-90) scale(10.6724 1.77254)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#909090"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#5C5C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#343434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#171717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#060606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint49_radial_39935_59277",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.0155 118.827) rotate(-90) scale(9.78303 4.87448)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#0090CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#006590"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#00405C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#002434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#001017"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#000406"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint50_radial_39935_59277",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(111.974 118.827) rotate(-90) scale(9.78303 4.87449)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#0090CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#006590"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#00405C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#002434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#001017"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#000406"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint51_radial_39935_59277",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(117.004 26.7261) rotate(-90) scale(13.3142 1.65848)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCC14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#8F8F0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#5C5C09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#343405"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#171702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#060600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_39935_59277",
    x1: 116.567,
    y1: 70.7903,
    x2: 126.9,
    y2: 70.7903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#335D94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#204270"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint53_radial_39935_59277",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(64.9795 101.779) scale(5.68326 5.70311)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#199FCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#1798C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#127498"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#0D556F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#093B4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#052530"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#03141B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#01090B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#000202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_39935_59277",
    x1: 8.14691,
    y1: 72.9842,
    x2: 8.14691,
    y2: 96.5146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6287C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B597D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint55_radial_39935_59277",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.14746 84.7489) scale(6.71657 6.74004)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_39935_59277",
    x1: 8.58485,
    y1: 93.1641,
    x2: 8.58485,
    y2: 96.5142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99B2BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BBD67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_39935_59277",
    x1: 8.14691,
    y1: 72.9842,
    x2: 8.14691,
    y2: 76.8129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94885C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C507A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_39935_59277",
    x1: 6.59718,
    y1: 76.0948,
    x2: 6.59718,
    y2: 93.9619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#739CB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#476B96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_39935_59277",
    x1: 10.1349,
    y1: 72.9842,
    x2: 10.1349,
    y2: 96.5146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#739CB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#476B96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_39935_59277",
    x1: 121.852,
    y1: 72.9842,
    x2: 121.852,
    y2: 96.5146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6287C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B597D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint61_radial_39935_59277",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(121.813 84.7489) rotate(180) scale(6.71661 6.74004)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFED88"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_39935_59277",
    x1: 121.375,
    y1: 93.1641,
    x2: 121.375,
    y2: 96.5142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99B2BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BBD67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_39935_59277",
    x1: 121.852,
    y1: 72.9842,
    x2: 121.852,
    y2: 76.8129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94885C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C507A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_39935_59277",
    x1: 123.402,
    y1: 76.0948,
    x2: 123.402,
    y2: 93.9619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#739CB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#476B96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_39935_59277",
    x1: 119.865,
    y1: 72.9842,
    x2: 119.865,
    y2: 96.5146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#739CB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#476B96"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint66_radial_39935_59277",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.1897 83.2469) rotate(-90) scale(20.333 8.34325)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCC14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#8F8F0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#5C5C09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#343405"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#171702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#060600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint67_radial_39935_59277",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(133.559 83.247) rotate(-90) scale(20.333 8.34325)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCC14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#8F8F0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#5C5C09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#343405"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#171702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#060600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint68_radial_39935_59277",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.3513 85.3329) rotate(-90) scale(40.457 1.64298)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFED00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#EADA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#A49800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#696200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#3C3700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#1B1900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#070600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint69_radial_39935_59277",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-196.862 83.7516) rotate(90) scale(20.2201 0.80599)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFED00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#EADA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#A49800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#696200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#3C3700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#1B1900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#070600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint70_radial_39935_59277",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.4765 85.3332) rotate(-90) scale(40.457 1.64298)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFED00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#EADA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#A49800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#696200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#3C3700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#1B1900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#070600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint71_radial_39935_59277",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(346.835 83.7523) rotate(90) scale(20.2201 0.80599)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFED00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#EADA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#A49800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#696200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#3C3700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#1B1900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#070600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_39935_59277",
    x1: 84.791,
    y1: 71.7513,
    x2: 54.6675,
    y2: 44.9935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78FAFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevel4);
export default __webpack_public_path__ + "static/media/level4.5ff2eb2eaf133a08be0615438fcaa90c.svg";
export { ForwardRef as ReactComponent };